import React, { useEffect, useRef } from 'react';
import './index.scss';
import PropTypes from 'prop-types';
import _ from 'lodash';

const CommonModal = ({
  closeDialogHandler,
  closeButtonIMG,
  children,
  isInitialFocusToClose,
  isFocusOutside
}) => {
  const closeButtonRef = useRef();
  const modalRef = useRef();

  useEffect(() => {
    isInitialFocusToClose && modalRef.current.focus();
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  });

  useEffect(() => {
    function keyListener(e) {
      if (e.keyCode === 27) {
        e.preventDefault();
        closeDialogHandler();
      }
    }
    document.addEventListener('keydown', keyListener);
    return () => document.removeEventListener('keydown', keyListener);
  });

  const closeDialog = () => {
    closeDialogHandler();
  };
  /* SCDTC-11981 -option and -dummyInput classes only for this ticket */
  const setFocusToCloseButton = event => {
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (!relatedClassName.includes('modalWrapper')) {
        if (
          relatedClassName.includes('dialogComponent') ||
          relatedClassName.includes('-option') ||
          relatedClassName.includes('-dummyInput') ||
          event.relatedTarget.id == 'react-select-2-input'
        ) {
          return;
        } else {
          if (isFocusOutside) {
            modalRef.current
              .getElementsByClassName('dialogComponent')[0]
              ?.focus();
          }
          {
            closeButtonRef.current.focus();
          }
        }
      }
    }
  };

  const onKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      closeDialog();
    }
  };
  return (
    <div className="commonModal">
      <div className="transparentBg" onClick={closeDialog}></div>
      <div
        className="modalContent"
        onBlur={setFocusToCloseButton}
        role="dialog"
        aria-labelledby="dialogTitleHeading"
        tabIndex={0}
      >
        <div className="modalContentHeader">
          <button
            className={`dialogComponent closeModal`}
            onClick={closeDialog}
            onKeyDown={onKeyDown}
            aria-label="Close"
            role="button"
            ref={closeButtonRef}
          >
            <img src={`/content/images/icons/${closeButtonIMG}`} alt="" />
          </button>
        </div>
        <div
          className="modalWrapper"
          {...(isInitialFocusToClose ? { tabIndex: '0' } : '')}
          ref={modalRef}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

CommonModal.propTypes = {
  closeDialogHandler: PropTypes.func,
  closeButtonIMG: PropTypes.string,
  children: PropTypes.element.isRequired,
  isInitialFocusToClose: PropTypes.bool,
  isFocusOutside: PropTypes.bool
};

CommonModal.defaultProps = {
  closeDialogHandler: () => {},
  closeButtonIMG: '',
  children: '',
  isInitialFocusToClose: false,
  isFocusOutside: false
};

export default CommonModal;
